import { render } from "./BaseDisabledCheckbox.vue?vue&type=template&id=37363795&scoped=true"
import script from "./BaseDisabledCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseDisabledCheckbox.vue?vue&type=script&lang=js"

import "./BaseDisabledCheckbox.vue?vue&type=style&index=0&id=37363795&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37363795"]])

export default __exports__